import React, { useEffect } from 'react';
import Experience from '../components/Experience/Experience';
import GetInTouch from '../components/Home/GetInTouch';
import HomeBlog from '../components/Home/HomeBlog';
import HomeProjects from '../components/Home/HomeProjects';
import Intro from '../components/Home/Introduction';
import Skills from '../components/Home/Skills';


const Home = () => {

    return (
        <main>
            <Intro />
            <Experience />
            <HomeProjects />
            <HomeBlog />
            <GetInTouch />

        </main>
    );
};

export default Home;